import styled from 'styled-components';
import AboutPage from './AboutPage';
import ContactPage from './ContactPage';
import HomePage from "./HomePage";
import ProjectsPage from './ProjectsPage';
import SkillsPage from './SkillsPage';
import StatisticsPage from './StatisticsPage';

const MainContentStyled = styled.main`
    position: relative;
    margin-left: 16.3rem;
    min-height: 100vh;
    @media screen and (max-width:1200px){
        margin-left: 0;
    }
    .lines{
        position: absolute;
        min-height: 100%;
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        opacity: 0.4;
        z-index: -1;
    .line-1, .line-2, .line-3, .line-4{
        width: 1px;
        min-height: 100vh;
        background-color: var(--border-color);
    }
}`

function AllRoutes({ theme }) {
    return (
        <MainContentStyled id="#">
            <div className="lines">
                <div className="line-1"></div>
                <div className="line-2"></div>
                <div className="line-3"></div>
                <div className="line-4"></div>
            </div>
            <HomePage />
            <AboutPage />
            <SkillsPage theme={theme} />
            <ProjectsPage />
            <StatisticsPage />
            <ContactPage />
        </MainContentStyled>
    )
}
export default AllRoutes